import * as React from "react";
import { Link, LinkProps } from "react-router-dom";
import styled from "styled-components";
import { IBtnDefaultProps, mixinWithBtnPropsFn } from "./btn_mixin";

interface IProps extends IBtnDefaultProps, LinkProps {}

const GoldLinkDefault: React.FC<IProps> = (props) => {
  const { icon, ...ButtonProps } = props;

  return <Link {...ButtonProps} />;
};

const GoldLink = styled(GoldLinkDefault)`
  color: #9a8c64;
  font-weight: bold;
  font-size: 12px;
  padding: 4px 20px;
  border-radius: 4px;
  :hover {
    background-color: #d9d9d94d;
  }
  ${(props) => mixinWithBtnPropsFn(props)}
`;

export default GoldLink;



// WEBPACK FOOTER //
// ./src/presentation/common/atom/btn/gold_link.tsx